import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';

import { MEDIA_QUERIES, PriceAmounts } from '@sm360/widget-commons-general';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { PurchaseMethods, CurrencyFormats } from '@sm360/widget-commons-vehicle';
import { CURRENCY_2 } from 'commons-vehicle/constants/currencyFormats.js';

import 'payment-calculator/components/PaymentCalculatorDetails/components/CalculatorRebatesTradeIn/CalculatorRebatesTradeIn.scss';

class CalculatorRebatesTradeIn extends React.Component {
    constructor(props) {
        super(props);

        this.showRebateLabel = this.showRebateLabel.bind(this);
        this.showTradeInLabel = this.showTradeInLabel.bind(this);

        this.state = {
            showRebateLabel: false,
            showTradeInLabel: false,
        };
    }

    showRebateLabel() {
        this.setState((prevState) => {
            return { showRebateLabel: !prevState.showRebateLabel };
        });
        setTimeout(() => {
            this.setState({
                showRebateLabel: false,
            });
        }, 4000);
    }
    showTradeInLabel() {
        this.setState((prevState) => {
            return { showTradeInLabel: !prevState.showTradeInLabel };
        });
        setTimeout(() => {
            this.setState({
                showTradeInLabel: false,
            });
        }, 4000);
    }

    render() {
        const costOfCredit = this.props.purchaseMethods.getSelectedFinanceCostOfCredit();
        const cashPurchaseObject = this.props.purchaseMethods.getSelectedPurchaseMethodAmounts();
        const rebatesClassWrapper = ['paymentCalculator__rebates sr-paymentCalculator-background'];
        if (this.state.showRebateLabel) {
            rebatesClassWrapper.push('is-readable');
        }

        const tradeInClassWrapper = ['paymentCalculator__tradeIn sr-paymentCalculator-background'];
        if (this.state.showTradeInLabel) {
            tradeInClassWrapper.push('is-readable');
        }
        const rebates =
            cashPurchaseObject.rebates > 0 || cashPurchaseObject.discounts > 0 ? (
                <div className={rebatesClassWrapper.join(' ')}>
                    <div className="paymentCalculator__rebates--term is-light " onClick={this.showRebateLabel}>
                        <icon className="icon-promo2 is-util" />
                        <MediaQuery minWidth={MEDIA_QUERIES.LAPTOP.MIN}>
                            <span>{LocaleService.t('PAYMENT_CALCULATOR.CALCULATOR_REBATES_TRADEIN.REBATE')}</span>
                        </MediaQuery>
                        <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                            <span>
                                {LocaleService.t('PAYMENT_CALCULATOR.CALCULATOR_REBATES_TRADEIN.REBATE_MOBILE')}
                            </span>
                        </MediaQuery>

                        <span>
                            <PriceAmounts
                                price={LocaleService.l(
                                    cashPurchaseObject.discounts + cashPurchaseObject.rebates,
                                    CurrencyFormats.CURRENCY_2
                                )}
                            />
                        </span>
                    </div>
                </div>
            ) : null;

        const tradeIn =
            cashPurchaseObject.tradeIn > 0 && !this.props.purchaseMethods.cashPurchase.selected ? (
                <div className={tradeInClassWrapper.join(' ')}>
                    <div className="paymentCalculator__tradeIn--term is-light" onClick={this.showTradeInLabel}>
                        <icon className="icon-refresh is-util" />

                        <MediaQuery minWidth={MEDIA_QUERIES.LAPTOP.MIN}>
                            <span>{LocaleService.t('PAYMENT_CALCULATOR.CALCULATOR_REBATES_TRADEIN.TRADEIN')}</span>
                        </MediaQuery>
                        <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                            <span>
                                {LocaleService.t('PAYMENT_CALCULATOR.CALCULATOR_REBATES_TRADEIN.TRADEIN_MOBILE')}
                            </span>
                        </MediaQuery>
                        <PriceAmounts price={LocaleService.l(cashPurchaseObject.tradeIn, CurrencyFormats.CURRENCY_2)} />
                    </div>
                </div>
            ) : null;
        if (tradeIn === null && rebates === null) {
            return null;
        }

        const paymentDetail = costOfCredit ? (
            <div className="paymentCalculator__tradeIn sr-paymentCalculator-background credit">
                <div className="paymentCalculator__rebates--term is-light">
                    <MediaQuery minWidth={MEDIA_QUERIES.LAPTOP.MIN}>
                        <span>{LocaleService.t('DOWN_PAYMENTS.TOTAL_CREDIT')}</span>
                    </MediaQuery>
                    <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                        <span>{LocaleService.t('DOWN_PAYMENTS.TOTAL_CREDIT')}</span>
                    </MediaQuery>
                    <PriceAmounts price={LocaleService.l(costOfCredit, CURRENCY_2)} />
                </div>
            </div>
        ) : null;
        if (paymentDetail === null && rebates === null) {
            return null;
        }

        return (
            <div className="paymentCalculator__rebatesWrapper clearfix">
                {rebates}
                {tradeIn}
                {paymentDetail}
            </div>
        );
    }
}

CalculatorRebatesTradeIn.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethods.PurchaseMethodsModel),
};

CalculatorRebatesTradeIn.displayName = 'CalculatorRebatesTradeIn';

export default CalculatorRebatesTradeIn;
